import { styled } from '@material-ui/core/styles'

export const CitysList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  columns: 1,
  columnGap: '4em',
  [theme.breakpoints.up('sm')]: {
    columns: 2,
  },
  [theme.breakpoints.up('md')]: {
    columns: 3,
  },
  [theme.breakpoints.up('lg')]: {
    columns: 4,
  },

  '& li': {
    fontSize: 16,
    letterSpacing: 0.5,
    margin: `${theme.spacing(1)}px 0`,
    '&:first-child': {
      marginTop: 0,
    },
  },
}))
